import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import CircleQuestion from 'components/application/CircleQuestion';
import Table from 'components/application/Table';
import Tooltip from 'components/application/Tooltip';

import CourseRow from 'components/courses/CourseRow';

export default function CoursesTable({ courses, onRowClick, originalCourses }) {
  const { t: i18nTCommon } = useTranslation('common');
  const { t: i18nTTrainingName } = useTranslation('components', {
    keyPrefix: 'training.TrainingName',
  });

  const formattedRows = courses.map((course) => {
    const originalCourseData = course.relationships.originalCourse.data;

    const originalCourse =
      originalCourseData ? originalCourses[originalCourseData.id] : null;

    return { course, originalCourse };
  });

  return (
    <Table
      headers={
        <tr>
          <th className='tw-w-16.5 tw-text-s tw-font-medium tw-tracking-wide tw-text-grey-900'>
            {i18nTCommon('shared.status')}
          </th>
          <th className='tw-w-[45%] tw-text-s tw-font-medium tw-tracking-wide tw-text-grey-900'>
            {i18nTCommon('shared.course')}
          </th>
          <th className='tw-w-[10%] tw-text-s tw-font-medium tw-tracking-wide tw-text-grey-900'>
            {i18nTCommon('shared.method')}
          </th>
          <th className='tw-w-[10%] tw-text-s tw-font-medium tw-tracking-wide tw-text-grey-900'>
            {i18nTCommon('courses.provider')}
          </th>
          <th className='tw-w-[15%] tw-text-s tw-font-medium tw-tracking-wide tw-text-grey-900'>
            {i18nTCommon('courses.renewalFrequency')}
          </th>
          <th className='tw-w-[10%] tw-text-center tw-text-s tw-font-medium tw-tracking-wide tw-text-grey-900'>
            {i18nTCommon('shared.roles')}
          </th>
          <th className='tw-w-[10%] tw-text-center tw-text-s tw-font-medium tw-tracking-wide tw-text-grey-900'>
            {i18nTCommon('shared.personnel')}
          </th>
          <th className='tw-w-[10%] tw-text-center tw-text-s tw-font-medium tw-tracking-wide tw-text-grey-900'>
            <div className='tw-inline-flex tw-items-center'>
              {i18nTCommon('shared.overrides')}
              <Tooltip
                className='tooltip-dark--max-w-xxs'
                placement='top'
                tooltip={i18nTTrainingName('overridden.tooltip')}
                trigger='hover'
                triggerProps={{
                  className: 'tooltip-trigger tw-static tw-ml-1',
                }}
              >
                <CircleQuestion size='sm' />
              </Tooltip>
            </div>
          </th>
        </tr>
      }
      rows={formattedRows.map((formattedRow) => (
        <CourseRow
          course={formattedRow.course}
          key={formattedRow.course.id}
          onRowClick={onRowClick}
          originalCourse={formattedRow.originalCourse}
        />
      ))}
    />
  );
}

CoursesTable.propTypes = {
  courses: PropTypes.array.isRequired,
  originalCourses: PropTypes.object.isRequired,
  onRowClick: PropTypes.func.isRequired,
};
